import React from 'react';
import { Menu as AntdMenu } from 'antd';
import { MenuProps as AntdMenuProps } from 'antd/lib/menu';

interface MenuProps extends AntdMenuProps {}

class Menu extends React.Component<MenuProps, {}> {
	static Item = AntdMenu.Item;
	static SubMenu = AntdMenu.SubMenu;
	static ItemGroup = AntdMenu.ItemGroup;

	render() {
		return <AntdMenu {...this.props} />;
	}
}
export default Menu;
